import pushDataLayer from '../../principles/events/pushDataLayer';
import {
  getVisitorId, getLandingPage, getReferer, getEmailRequired,
  getSubjects, getLocale
} from '../../leadform/models/form';

/**
 * Sends the account_created event to Google Tag Manager
 * @param {Element} form - The form object on the page
 * @param {*} data - The JSON data received from the createUserAsync call
 */
export function pushAccountCreated(form, obj = {}) {
  pushDataLayer(Object.assign({
    'event': 'account_created',
    'landing_page': getLandingPage(form),
    'page': location.href,
    'visitor_id': getVisitorId(form),
    'email': getEmailRequired(form),
  }, obj));
}

/**
 * Sends the lead_created event to Google Tag Manager
 * @param {Element} form - The form object on the page
 * @param {*} data - The JSON data received from the createUserAsync call
 */
export function pushLeadCreated(form, obj = {}) {
  pushDataLayer(Object.assign({
    'event': 'lead_created',
    'landing_page': getLandingPage(form),
    'page': location.href,
    'locale': getLocale(form),
    'referer': getReferer(form),
    'subject': getSubjects(form),
    'lead_type': 'learning_tools_lead',
    'email': getEmailRequired(form),
    'visitor_id': getVisitorId(form),
  }, obj));
}
